export default __webpack_public_path__ + "static/media/mesIcon2.65d0016c.png";